import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.css']
})
export class ThemeToggleComponent {
  @Input() isDarkMode: boolean = false;
  @Output() themeChange = new EventEmitter<boolean>();

  toggleTheme() {
    this.isDarkMode = !this.isDarkMode;
    this.themeChange.emit(this.isDarkMode);
  }
} 